module.exports = __webpack_public_path__ + "static/media/ios-square.fe7e060b.svg";